import { useMutation } from "@tanstack/react-query";
import { activateMetaIntegration } from "../../api/bMetaApi";

export const useActivateMeta = () => {
  return useMutation({
    mutationKey: ["activate-meta"],
    mutationFn: (data) => activateMetaIntegration(data),
    onError: (error) => {
      console.error("Meta Ads integration error details:", error.response || error);
    },
  });
};